import api from '../utils/api';

export type ChecklistItemId =
  | 'add_clinic_logo'
  | 'set_tax_rate'
  | 'connect_stripe'
  | 'set_up_service_pricing'
  | 'set_up_appointment_types'
  | 'set_up_soap_templates'
  | 'invite_team'
  | 'enable_offline'
  | 'add_inventory_item'
  | 'add_first_client'
  | 'add_first_horse'
  | 'schedule_first_appointment'
  | 'complete_first_soap'
  | 'send_first_discharge'
  | 'create_first_invoice'
  | 'record_first_payment';

export type ChecklistTier = 'setup' | 'data' | 'workflow';

export interface ChecklistItem {
  id: ChecklistItemId;
  tier: ChecklistTier;
  title: string;
  description: string;
  completed: boolean;
  actionHref: string;
}

export interface ChecklistTierSummary {
  tier: ChecklistTier;
  title: string;
  items: ChecklistItem[];
  completedCount: number;
  totalCount: number;
}

export interface OnboardingStateShape {
  lastActiveTourId?: string;
  tourProgress?: Record<
    string,
    { startedAt: string; completedAt?: string; lastStepId?: string }
  >;
  dismissedHotspots?: string[];
  dismissedAnnouncements?: string[];
  manuallyCompletedItems?: ChecklistItemId[];
}

export interface OnboardingResponse {
  firstLoginAt: string | null;
  onboardingCompletedAt: string | null;
  onboardingDismissedAt: string | null;
  progress: { completed: number; total: number; percent: number };
  tiers: ChecklistTierSummary[];
  state: OnboardingStateShape;
}

export interface UpdateOnboardingPayload {
  dismissed?: boolean;
  revived?: boolean;
  lastActiveTourId?: string;
  tourProgress?: OnboardingStateShape['tourProgress'];
  dismissedHotspots?: string[];
  dismissedAnnouncements?: string[];
  manuallyCompletedItems?: ChecklistItemId[];
}

export const onboardingService = {
  async getState(): Promise<OnboardingResponse> {
    const response = await api.get('/onboarding');
    return response.data;
  },

  async updateState(payload: UpdateOnboardingPayload): Promise<OnboardingResponse> {
    const response = await api.patch('/onboarding', payload);
    return response.data;
  },
};
